<div 
  gaCategory="View Media Bar"
  class="view-scrubber" 
  [ngClass]="{'view-scrubber--draggable': showHandle}"
  #scrubber>
  <div class="view-scrubber__track" #track (click)="handleTrackClick($event)">
    <div class="view-scrubber__bar" #bar></div>
  </div>

  <div 
    gaEvent
    gaAction="Clicked Scrubber"
    #handle
    class="view-scrubber__handle" 
    cdkDrag 
    cdkDragLockAxis="x"
    cdkDragBoundary=".view-scrubber"
    [cdkDragFreeDragPosition]="dragPosition"
    (cdkDragStarted)="handleDragStart()"
    (cdkDragEnded)="handleDragEnd()"
    [ngClass]="{'view-scrubber__handle--hide': !showHandle, 'view-scrubber__handle-touch': canTouch$ | async }"></div>
</div>